export const appSymbol = Symbol();
